<template>
    <div 
        id="main-block" 
        class="o-movie-details"
    >
        <OMovieHeroBlock
            :title="title"
            :genres="genres"
            :rating="rating"
            :premier="premier"
            :duration="duration"
            :cover-url="coverUrl"
            :poster-url="posterUrl"
            :description="description"
            :original-title="originalTitle"
            :original-language="originalLanguage"
            @onCLick="scrollToTickets"
        />
        <OMovieSchedule
            id="tickets"
            @onBuyTicket="onBuyTicket"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import OMovieSchedule from '../../unique-organisms/o-movie-schedule';
import OMovieHeroBlock from '../../unique-organisms/o-movie-hero-block';

import { getFormattedMovieDescription } from "@/components/organisms/o-movie-details/o-movie-details-service";
import { SHOW_MODAL } from "../../../utils/constants/bus-events-constants";

export default {
    name: 'OMovieDetails',
    data() {
        return {
            placeholder: true,
            movieId: this.$route.query.movieId
        }
    },
    components: {
        OMovieSchedule,
        OMovieHeroBlock
    },
    computed: {
        ...mapGetters([
            'getMovieById'
        ]),
        movie() {
            return this.getMovieById(this.movieId) || {};
        },
        posterUrl() {
            return this.movie.Images[1].Url || '';
        },
        coverUrl() {
            return this.movie.Images[0].Url || '';
        },
        description() {
            return this.movie.LongDescription || '';
        },
        title() {
            return this.movie.Title || '';
        },
        genres() {
            return this.movie.GenresAsCommaString || '';
        },
        duration() {
            return getFormattedMovieDescription(this.movie.Length) || '';
        },
        rating() {
            return this.movie.Rating.Description || '';
        },
        premier() {
            return this.movie.Rating.premier || '';
        },
        originalTitle() {
            return this.movie.OriginalTitle || '';
        },
        originalLanguage() {
            return this.movie.OriginalLanguage || '';
        }
    },
    methods: {
        scrollToTickets() {
            const ticketsBlock = document.getElementById('tickets');
            const container = document.getElementById('main-block');
            const scrollToValue = ticketsBlock.scrollHeight;

            container.scrollTo({ top: scrollToValue, behavior: 'smooth'});
        },
        onBuyTicket(data) {
            const payload = {
                component: 'buyTicketMovie',
                data: {
                    ...data,
                    title: this.title
                },
                clickOutside: true
            };

            this.$bus.$emit(SHOW_MODAL, payload)
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />